export default __webpack_public_path__ + "static/media/cloze-dropdown-blue.89e60baa.svg";